<template>
  <div class="bool-input">
    <ValidationProvider v-slot="{ errors }" :name="label">
      <label
        v-if="label || required"
        :for="`input-${name}`"
        class="vs-input--label"
        >{{ label }}
        <span v-if="required" class="text-danger"
          ><feather-icon icon="star-of-life"/></span
      ></label>
      <vs-switch
        v-model="internalValue"
        type="button"
        :name="name"
        class="lg:mt-2"
        :disabled="disabled"
      >
        <template #off>
          {{ switchOff }}
        </template>
        <template #on>
          {{ switchOn }}
        </template>
      </vs-switch>
      <span v-show="errors.length" class="text-danger text-sm">{{
        errors[0]
      }}</span>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: [Boolean, Number], default: null },
    label: { type: String, default: null },
    name: { type: String, required: true },
    type: { type: String, default: "text" },
    switchOn: { type: String, default: "Ja" },
    switchOff: { type: String, default: "Nein" },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    numberValue: { type: Boolean, default: false }
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", this.numberValue ? +value : value);
      }
    }
  }
};
</script>
